<template>
  <div>
    <VueMultiselect
      v-bind="dynamicProps"
      v-model="selectedOptions"
      :options="options"
      ref="tcMultiselect"
      :class="{ 'hide-no-options': dynamicProps?.showNoOptions === false }"
      @tag="emitOnTag"
      @close="emitOnClose"
      @input="emitOnInput"
      @open="emitOnOpen"
      @search-change="emitOnSearch"
      @select="emitOnSelect"
    >
      <template v-for="(_, slotName, i) in $slots" #[slotName]="slotProps" :key="i">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </VueMultiselect>
  </div>
</template>

<script setup>
import VueMultiselect from 'vue-multiselect';
import { computed } from 'vue';

const emit = defineEmits([
  'update:modelValue',
  'onUpdate',
  'onTag',
  'onSearch',
  'onClose',
  'onInput',
  'onOpen',
  'onSelect',
]);
const props = defineProps({
  modelValue: [String, Object],
  dynamicProps: Object,
  options: Array,
  onUpdate: [Function, Promise],
});

const selectedOptions = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    if (props.onUpdate) props.onUpdate(value);
    emit('update:modelValue', value);
    emit('onUpdate', value);
  },
});

const emitOnTag = value => {
  emit('onTag', value);
};

const emitOnInput = value => {
  emit('onInput', value);
};

const emitOnSearch = value => {
  emit('onSearch', value);
};

const emitOnClose = value => {
  emit('onClose', value);
};

const emitOnOpen = value => {
  emit('onOpen', value);
};

const emitOnSelect = value => {
  emit('onSelect', value);
};
</script>
